export default __webpack_public_path__ + "static/1194-8041a9513fe6c669ac5d4849a6fc9250.gif";